import { Component, OnInit, inject } from "@angular/core";
import { Auth0AuthorizationService } from "@mrdm-self-service-frontend/shared/util-authorization";
import { OrganizationPermissionService } from "../../authorization";
import { NameId } from "@mrdm-self-service-frontend/shared/types";
import { IDropdownDefinition } from "@logex/framework/ui-core";
import {
    SharedAppUser,
    SharedConfigService
} from "@mrdm-self-service-frontend/shared/util-logex-framework-setup";
import { Router } from "@angular/router";
import { SharedUserAuthorizationService } from "@mrdm-self-service-frontend/shared/data-access-authorization";
import { LG_USER_INFO } from "@logex/framework/lg-application";

@Component({
    selector: "mrdm-self-service-frontend-ui-sidebar-account",
    templateUrl: "./ui-sidebar-account.component.html",
    styleUrls: ["./ui-sidebar-account.component.scss"],
    host: {
        class: "lg-sidebar-account lg-sidebar-panel"
    },
    standalone: false
})
export class UiSidebarAccountComponent implements OnInit {
    private _sharedAuthService = inject(SharedUserAuthorizationService);
    private _auth0 = inject(Auth0AuthorizationService);
    private _organizationPermissions = inject(OrganizationPermissionService);
    private _configService = inject(SharedConfigService);
    private _router = inject(Router);
    _userInfo = inject<SharedAppUser>(LG_USER_INFO);

    public _currentOrgId: number | null = null;
    public _organizationsDropdownDefinition: IDropdownDefinition<number> | null = null;
    public _singleOrganizationName = "";

    ngOnInit(): void {
        this._organizationPermissions.allowedOrganizations$.subscribe((organizations: NameId[]) => {
            if (organizations.length === 1) {
                this._organizationsDropdownDefinition = null;
                this._singleOrganizationName = organizations[0].name;
            } else {
                this._organizationsDropdownDefinition = { groups: [{ entries: organizations }] };
                this._singleOrganizationName = "";
            }
        });

        this._sharedAuthService.organizationId$.subscribe(orgId => {
            this._currentOrgId = orgId;
        });
    }

    _switchOrganization(organizationId: number): void {
        if (this._currentOrgId == null) {
            this._router.navigate(["/", "organization", organizationId]);
        } else {
            this._router.navigateByUrl(
                this._router.url.replace(this._currentOrgId.toString(), organizationId.toString())
            );
        }
    }

    _logout(e?: Event): void {
        e?.stopPropagation();
        e?.preventDefault();
        this._auth0.logout();
    }

    _goToMyAccount(): void {
        window.open(this._configService.myAccountUrl, "_blank");
    }
}
